export default {
  value: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: () => String(''),
  },
  title: {
    type: String,
    default: () => String('KPI'),
  },
  ...[
    'languagesList',
    'qaMethodsList',
    'qaModelsList',
    'textCategoryList',
    'industryFieldList',
    'reportTypeList',
  ].reduce((acc, key) => {
    acc[key] = {
      type: Array,
      required: true,
    };
    return acc;
  }, Object()),
};
